var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7222 37.3751H14.5195V21.1182H13.207V38.1877C13.207 38.6362 13.5009 38.9998 13.8633 38.9998H35.3785C35.7409 38.9998 36.0347 38.6362 36.0347 38.1877L36.0346 21.1182H34.7222L34.7222 37.3751Z",
    fill: "url(#paint0_linear_2173_8616)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8187 9.10237C24.6204 8.96588 24.3792 8.96588 24.181 9.10237L9.5 19.2031L10.1377 20.6227L24.5 10.7415L38.8623 20.6227L39.5 19.2031L24.8187 9.10237Z",
    fill: "url(#paint1_linear_2173_8616)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3589 20.9131H20.8711C20.5087 20.9131 20.2148 21.2767 20.2148 21.7252V30.9913C20.2148 31.4399 20.5087 31.8035 20.8711 31.8035H28.3589C28.7214 31.8035 29.0152 31.4399 29.0152 30.9913V21.7252C29.0152 21.2767 28.7214 20.9131 28.3589 20.9131ZM21.5272 22.5372H23.9586V25.546L21.5272 25.5461V22.5372ZM21.5272 30.1795V27.1706H23.9586V30.1795H21.5272ZM27.7026 27.1706V30.1795H25.2712V22.5372H27.7027V25.5461H26.2087V27.1702L27.7026 27.1704V27.1706Z",
    fill: "url(#paint2_linear_2173_8616)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_8616",
    x1: 13.207,
    y1: 30.059,
    x2: 36.0347,
    y2: 30.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2173_8616",
    x1: 9.5,
    y1: 14.8113,
    x2: 39.5,
    y2: 14.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2173_8616",
    x1: 20.2148,
    y1: 26.3583,
    x2: 29.0152,
    y2: 26.3583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.670f4b0f6562ebeb8fda0aa8f504bf6d.svg";
export { ForwardRef as ReactComponent };